module.exports = __webpack_public_path__ + "img/audiobooksadults.73ab01eb.jpg";